import {
  ADD_MAPPED_FIELDS_TO_PROFILE,
  ADD_RULES_IDS_TO_PROFILE,
  BLUR_PROFILE_FIELD_SUCCESS,
  FETCH_PROFILE_COMPLETE,
  FETCH_PROFILE_ERROR,
  FETCH_PROFILE_LIST_SUCCESS,
  FETCHING_PROFILE, FETCHING_PROFILES_LIST,
  RESET_PROFILE,
  SET_POSITION_IDENTIFIER_SUCCESS,
  SET_PROFILE_FOR_EDITION,
  UPDATE_PROFILE_FIELD_SUCCESS,
  UPDATE_TARGET_FIELDS_ID,
  SET_PROFILE_EDITION_MODE,
  RESET_PROFILE_EDITION_MODE
} from './ProfilesConstants';
import mappingActionTypes from '../mapping/MappingConstants';
import { EXCEL_FILE, getFileTypeCategory } from '../../shared/helpers/fileTransferHelper';
import { NEW, UPDATE } from "shared/constants/SharedConstants";

const initialStore = {
  positionIdentifier: 1,
  profilesList: [],
  profilesListGridData: [],
  profile: {
    id: null,
    targetId: null,
    name: '',
    description: '',
    mapId: null,
    dateFormat: 'YYYY/MM/DD',
    thousandsSeparator: ',',
    decimalSeparator: '.',
    columnDelimiter: '|',
    transformedFileType: '',
    stripCurrencySymbols: '',
    maps: [],
    ruleSets: {
      ruleIds:[]
    },
    translationsId: [],
    isAudit: false,
    transactionType: '2',
    calculationType: '1'
  },
  pristineForm: true,
  mappedFieldsCount: 0,
  fetchingProfile: false,
  fetchingProfilesList: false,
  profileEditionMode: NEW
};

const createOrReturnExistingSubGroup = (prevValue, currentValue, posIdentifier, criteria, fileType) => (
  !prevValue[currentValue[criteria]] ?
    {
      ...prevValue,
      [currentValue[criteria]]: {
        identifier: currentValue.subGroup,
        posIdentifier: getFileTypeCategory(fileType) === EXCEL_FILE ? currentValue.activeDivision + 1 : posIdentifier,
        fields: []
      }
    } :
    prevValue
);

const ProfileReducer = (state = initialStore, action) => {
  switch (action.type) {
    case FETCH_PROFILE_LIST_SUCCESS:
      return {
        ...state,
        profilesList: action.profilesList,
        profilesListGridData: action.profilesList.map(({id, name, description, map }) => ({ id, name, description, fileType: map.transformedFileType })),
        fetchingProfilesList: false
      };
    case UPDATE_PROFILE_FIELD_SUCCESS:
      return { ...state, profile: { ...state.profile, [action.fieldName]: action.fieldValue }, pristineForm: false };
    case RESET_PROFILE:
      return { ...state, profile: { ...initialStore.profile }, pristineForm: true, mappedFieldsCount: 0 };
    case mappingActionTypes.RESET_IMPORT_MAPPING_DATA_SUCCESS:
      return { ...state, profile: { ...state.profile, maps:[], translationsId: [] }, mappedFieldsCount: 0};
    case BLUR_PROFILE_FIELD_SUCCESS:
      return { ...state, pristineForm: false };
    case SET_POSITION_IDENTIFIER_SUCCESS:
      return { ...state, positionIdentifier: action.position };
    case ADD_MAPPED_FIELDS_TO_PROFILE: //eslint-disable-line no-case-declarations
      //This criteria thing is because excel multisheet uses the posIdentifier to indicate the sheet pos, and csv files uses the posIdentifier for indicate the subGroup label position.
      const criteria = getFileTypeCategory(state.profile.transformedFileType) === EXCEL_FILE ? 'activeDivision' : 'subGroup';
      const subGroups = action.mappedFields.reduce((prevValue, currentValue) => createOrReturnExistingSubGroup(prevValue, currentValue, state.positionIdentifier, criteria, state.profile.transformedFileType), {} );
      action.mappedFields.forEach(({ targetField, sourceField, ...element }) => subGroups[element[criteria]].fields.push({ targetField, sourceField }));
      return { ...state, profile: { ...state.profile, maps: [ ...Object.keys(subGroups).map(key => subGroups[key])] }, mappedFieldsCount: action.mappedFields.length };
    case ADD_RULES_IDS_TO_PROFILE:
      return { ...state, profile: { ...state.profile, ruleSets: { ruleIds: [ ...action.ruleIds ]} }};
    case UPDATE_TARGET_FIELDS_ID:
      return { ...state, profile: { ...state.profile, targetId: action.targetId } };
    case SET_PROFILE_FOR_EDITION: //eslint-disable-line no-case-declarations
      const {
        targetId,
        id,
        name,
        description,
        map: {
          id: mapId,
          dateFormat,
          thousandsSeparator,
          decimalSeparator,
          separator,
          maps,
          transformedFileType,
          translationsId
        },
        ruleSets,
        isAudit, 
        transactionType, 
        calculationType, 
        ...rest //eslint-disable-line no-unused-vars
      } = action.profile; 
      return {
        ...state,
        profile: {
          ...state.profile,
          targetId,
          id,
          name,
          description,
          mapId,
          dateFormat,
          thousandsSeparator,
          decimalSeparator,
          columnDelimiter: separator,
          transformedFileType,
          maps,
          ruleSets: {
            ruleIds: ruleSets.rules.map(({ id }) => id )
          },
          isAudit,
          translationsId,
          transactionType,
          calculationType
        },
        mappedFieldsCount: action.mappedFields.length
      };
    case FETCHING_PROFILE:
      return { ...state, fetchingProfile: true };
    case FETCH_PROFILE_COMPLETE:
      return { ...state, fetchingProfile: false };
    case FETCH_PROFILE_ERROR:
      return { ...state, fetchingProfile: false };
    case FETCHING_PROFILES_LIST:
      return { ...state, fetchingProfilesList: true };
    case SET_PROFILE_EDITION_MODE:
      return { ...state, profileEditionMode: UPDATE };
    case RESET_PROFILE_EDITION_MODE:
      return { ...state, profileEditionMode: NEW };
    default:
      return state;
  }
};

export default ProfileReducer;



// WEBPACK FOOTER //
// ./src/redux/profiles/ProfilesReducer.js